import { render, staticRenderFns } from "./WXOfficialAccounts.vue?vue&type=template&id=21916b00&scoped=true&"
import script from "./WXOfficialAccounts.vue?vue&type=script&lang=js&"
export * from "./WXOfficialAccounts.vue?vue&type=script&lang=js&"
import style0 from "./WXOfficialAccounts.vue?vue&type=style&index=0&id=21916b00&scoped=true&lang=css&"
import style1 from "./WXOfficialAccounts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21916b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21916b00')) {
      api.createRecord('21916b00', component.options)
    } else {
      api.reload('21916b00', component.options)
    }
    module.hot.accept("./WXOfficialAccounts.vue?vue&type=template&id=21916b00&scoped=true&", function () {
      api.rerender('21916b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WX/WXOfficialAccounts.vue"
export default component.exports